import { render, staticRenderFns } from "./TltUseRcrd.vue?vue&type=template&id=4e3862f5&"
import script from "./TltUseRcrd.vue?vue&type=script&lang=js&"
export * from "./TltUseRcrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports